import { render, staticRenderFns } from "./DepartmentButton.vue?vue&type=template&id=33ad0b78&scoped=true"
import script from "./DepartmentButton.vue?vue&type=script&lang=js"
export * from "./DepartmentButton.vue?vue&type=script&lang=js"
import style0 from "./DepartmentButton.vue?vue&type=style&index=0&id=33ad0b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad0b78",
  null
  
)

export default component.exports